import {subDays} from "date-fns";
import {TZDate} from "react-day-picker";

import {wholeDayRange} from "@/components/datePicker/DatePickerURLRangeParams.utils.ts";

// The names legacy uses (web/status_pages/display/StatusPageDisplayController.jsx:196), so a link
// shared from either frontend opens the same window in the other.
export const DATE_RANGE_START_PARAM = "start";
export const DATE_RANGE_END_PARAM = "end";

/**
 * Resolve a status page's configured default range (in days) into a picker selection.
 *
 * Day boundaries are the status page's, not the viewer's: the backend resolves the requested days in
 * the page timezone, and snapping in browser-local time leaves the rendered window straddling the
 * returned one, whose uncovered edge shows up as no-data.
 */
export const defaultDateRangeForDays = (days: number, timezone?: string | null): {from: Date; to: Date} => {
  const now: Date = timezone ? new TZDate(new Date(), timezone) : new Date();
  // Neither the model nor the settings form enforces a minimum, and a saved 0 would run the range
  // start into tomorrow — an inverted window the bar cannot draw.
  return wholeDayRange(subDays(now, Math.max(days, 1) - 1), now);
};
